import { ArrowUpward } from "@mui/icons-material";
import { IconButton, Slide } from "@mui/material";
import { useEffect, useState } from "react";

export default function ScrollButton() {
  const [visible, setVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = document.documentElement.scrollTop;
      if (scrolled > 2000) {
        setVisible(true);
      } else if (scrolled <= 2000) {
        setVisible(false);
      }
    };
    window.addEventListener("scroll", toggleVisible);
    return () => {
      window.removeEventListener("scroll", toggleVisible);
    };
  }, []);

  return (
    <Slide in={visible} direction="left" mountOnEnter unmountOnExit>
      <IconButton
        onClick={scrollToTop}
        sx={{
          borderRadius: 1,
          opacity: 0.4,
          position: "fixed",
          right: 5,
          bottom: 40,
          fontSize: "2em",
          color: "white",
          bgcolor: "primary.main",
          "&:hover": { bgcolor: "primary.main" },
        }}
      >
        <ArrowUpward fontSize="inherit" />
      </IconButton>
    </Slide>
  );
}
